<div v-if="shouldRenderConfig" v-bind:class="getClassName">
    {{getWebProductName}}
</div>

